import React from "react";
import { Image } from "../Image/Image";
import cn from "classnames";
import { ImageType, Promo } from "@core/types";

interface IPromoCategory {
  promo: Promo;
  promoImage: ImageType;
  className?: string;
  onClick?: (promo: Promo) => void;
  isLastSingle?: boolean;
}

const PromoCategory = ({ promo, promoImage, className, onClick, isLastSingle }: IPromoCategory) => {
  return (
    <div
      onClick={() => onClick?.(promo)}
      className={cn("relative overflow-hidden rounded-[1.125rem] min-w-[6.25rem] min-h-[6.25rem] ", className)}
    >
      <Image
        alt={promo.title}
        image={promoImage}
        placeholder={promoImage.base64}
        lazyLoad={false}
        className={cn("w-full h-40 lg:h-full object-cover", {
          "h-[10rem] object-cover": isLastSingle,
        })}
      />

      <div className="absolute top-0 left-0 right-0 z-10 w-full h-[70px] pointer-events-none bg-gradient-to-b from-black/65 to-transparent mr-2" />

      <span className="m-1 absolute top-1 left-2 text-[16px] z-20 font-bold text-white [text-shadow:_0px_0px_0px_rgba(0,0,0,0.8),_0_0_1px_rgba(0,0,0,1)]">
        {promo.title}
      </span>
    </div>
  );
};

export default PromoCategory;
